// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"bQ-z","categoryName":"cQ-z","categoryNameSearchHeader":"dQ-z","categoryContent":"eQ-z","bottomAligned":"fQ-z","image":"gQ-z","imageNoBackground":"hQ-z"};